import { useState, useEffect } from "react";
import { getProvidersTariffs } from "Commons/Modules/Provider/misc/Api.js";

function useFetchProvidersWithTariffs({ postalcode, categoryType, locationId, yearlyConsumption, isOffice }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProvidersWithTariffs = async () => {
      setLoading(true);
      try {
        const providersWithTariffs = await getProvidersTariffs(
          postalcode,
          categoryType,
          locationId,
          yearlyConsumption,
          isOffice
        );
        setData(providersWithTariffs);
        setLoading(false);
      } catch (error) {
        setError(error.message);
        setLoading(false);
      }
    };
    fetchProvidersWithTariffs();
  }, [postalcode, categoryType, locationId, yearlyConsumption, isOffice]);

  return { loading, error, data };
}

export { useFetchProvidersWithTariffs };
